import { Tab, Nav, Accordion } from "react-bootstrap";
import "./FAQSection.css";
import CommonHeading from "../../common-component/common-heading/CommonHeading";

const programOverviewFAQs = [
  {
    question: "Are ATLAS Online programs UGC-recognized?",
    answer:
      "Yes. ATLAS SkillTech University offers its Online MBA through its recognized online learning framework.",
  },
  {
    question: "Can I pursue this MBA while working?",
    answer:
      "Yes. The program is designed for working professionals with a flexible online learning format and live interactive sessions.",
  },
  {
    question: "What is the duration of the ATLAS Online MBA?",
    answer:
      "The Online MBA is a 2-year program. Students can take an adaptive pace and have up to 4 years to complete the program.",
  },
  {
    question: "Is this MBA AI-focused?",
    answer:
      "Yes. The MBA is designed as an AI-native program, with AI embedded across the curriculum and hands-on learning with modern AI tools.",
  },
  {
    question: "What is the learning format?",
    answer:
      "The program follows a live and flexible online learning format with interactive learning designed for working professionals.",
  },
  {
    question: "How many credits is the MBA?",
    answer:
      "The ATLAS Online MBA consists of 87 credits across four semesters.",
  },
  {
    question: "Can I choose electives?",
    answer:
      "The curriculum includes core and vocational courses across the four semesters, with the specific course structure determined by the program curriculum.",
  },
  {
    question: "Is there any global exposure?",
    answer:
      "Yes. Students can access global exposure through international learning experiences, global faculty, and opportunities for global immersions.",
  },
  {
    question: "Can I pursue this MBA while working?",
    answer:
      "Yes. The flexible online structure is designed to help working professionals balance their MBA studies with their professional commitments.",
  },
  {
    question: "What support is available during the program?",
    answer:
      "Students receive academic and career-oriented support, including mentor support, industry projects, placement support, and access to an AI-powered learning platform.",
  },
];

const admissionFAQs = [
  {
    question: "Who can apply for the ATLAS Online MBA?",
    answer:
      "Candidates with a recognized undergraduate degree and a minimum of 50% aggregate marks can apply. The program is also designed for working professionals, future leaders, and entrepreneurs.",
  },
  {
    question: "What are the eligibility requirements?",
    answer:
      "Applicants must hold a recognized bachelor's degree with a minimum of 50% aggregate marks.",
  },
  {
    question: "How can I apply for the ATLAS Online MBA?",
    answer:
      "Applicants can apply online by completing the application form and submitting the required documents.",
  },
  {
    question: "What documents are required for admission?",
    answer:
      "Applicants need to submit the required academic and personal documents as part of the online application and document verification process.",
  },
  {
    question: "Is there an entrance examination?",
    answer:
      "The admission process outlined on the program page involves submitting the application and required documents, followed by completing the program fee payment to reserve a seat.",
  },
  {
    question: "Can working professionals apply for the program?",
    answer:
      "Yes. The program is specifically designed with working professionals in mind, and its flexible learning format allows them to pursue the MBA alongside their careers.",
  },
  {
    question: "What is the admission process?",
    answer:
      "The admission process involves three main steps: submitting the online application and required documents, completing the program fee payment to reserve your seat, and starting the program on the designated cohort start date.",
  },
  {
    question: "Is admission assistance available?",
    answer:
      "Yes. Applicants can receive assistance throughout the application and enrollment process.",
  },
];

function FAQList({ faqs }) {
  return (
    <Accordion className="faq-accordion">
      {faqs.map((faq, index) => (
        <Accordion.Item
          eventKey={index.toString()}
          className="faq-item"
          key={index}
        >
          <Accordion.Header>
            <span className="faq-question-text">{faq.question}</span>
          </Accordion.Header>

          <Accordion.Body>{faq.answer}</Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}

function FAQSection() {
  return (
    <section className="faq-section">
      <div className="container">
        <div className="row align-items-start">
          <div className="col-12 col-md-4">
            {/* <div className="faq-heading">
              <h2 className="faq-heading-title">Frequently Asked</h2>

              <span className="faq-heading-subtitle">Questions</span>
            </div> */}

            <CommonHeading subTitle={"Frequently Asked"} title={"Questions"} />
          </div>

          <div className="col-12 col-md-8">
            <div className="faq-box">
              <Tab.Container defaultActiveKey="program">
                <div className="faq-tabs-wrapper">
                  <Nav className="faq-tabs">
                    <Nav.Item className="faq-tab-item">
                      <Nav.Link eventKey="program" className="faq-tab">
                        <span className="faq-tab-text">Program Overview</span>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item className="faq-tab-item">
                      <Nav.Link eventKey="admissions" className="faq-tab">
                        <span className="faq-tab-text">Admissions</span>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>

                <div className="faq-tab-content-wrapper">
                  <Tab.Content className="faq-tab-content">
                    <Tab.Pane eventKey="program" className="faq-program-pane">
                      <FAQList faqs={programOverviewFAQs} />
                    </Tab.Pane>

                    <Tab.Pane
                      eventKey="admissions"
                      className="faq-admissions-pane"
                    >
                      <FAQList faqs={admissionFAQs} />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
